$(document).ready(function () {
    const $viewport = $(".js-imap-canvas");
    const $map = $(".js-imap-map");
    const $markers = $(".js-imap-markers");
    const $image = $(".js-imap-image");

    const minScale = 1;
    const maxScale = 5;

    let scale = 1;
    let offsetX = 0;
    let offsetY = 0;

    let isDragging = false;
    let dragStartX, dragStartY;

    function clampOffsets() {
        const mapWidth = $map.outerWidth() * scale;
        const mapHeight = $map.outerHeight() * scale;
        const viewportWidth = $viewport.width();
        const viewportHeight = $viewport.height();

        const maxOffsetX = 0;
        const minOffsetX = viewportWidth - mapWidth;

        const maxOffsetY = 0;
        const minOffsetY = viewportHeight - mapHeight;

        offsetX = Math.min(maxOffsetX, Math.max(minOffsetX, offsetX));
        offsetY = Math.min(maxOffsetY, Math.max(minOffsetY, offsetY));
    }

    function applyTransform() {
        clampOffsets();

        // transform map
        $map.css('transform', `translate(${offsetX}px, ${offsetY}px) scale(${scale})`);

        // transform markers
        $markers.css('transform', `translate(${offsetX}px, ${offsetY}px)`);

        updateMarkerPositions();
    }

    function updateMarkerPositions() {
        const renderedWidth = $image.width();
        const renderedHeight = $image.height();

        const scaledWidth = renderedWidth * scale;
        const scaledHeight = renderedHeight * scale;

        $markers.width(scaledWidth).height(scaledHeight);
    }

    function zoomAt(newScale) {
        const rect = $viewport[0].getBoundingClientRect();
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;

        const prevScale = scale;
        scale = Math.max(minScale, Math.min(maxScale, newScale));

        const scaleFactor = scale / prevScale;

        offsetX = centerX - (centerX - offsetX) * scaleFactor;
        offsetY = centerY - (centerY - offsetY) * scaleFactor;

        applyTransform();
    }

    $(".js-imap-zoom-plus").on("click", function () {
        zoomAt(scale + 0.5);
    });

    $(".js-imap-zoom-minus").on("click", function () {
        zoomAt(scale - 0.5);
    });

    $viewport.on("mousedown", function (e) {
        isDragging = true;
        dragStartX = e.clientX - offsetX;
        dragStartY = e.clientY - offsetY;
        $viewport.css('cursor', 'grabbing');
    });

    $(document).on("mousemove", function (e) {
        if (!isDragging) return;

        offsetX = e.clientX - dragStartX;
        offsetY = e.clientY - dragStartY;
        applyTransform();
    });

    $(document).on("mouseup", function () {
        isDragging = false;
        $viewport.css('cursor', 'default');
    });

    applyTransform();



    $(".js-imap-marker").click(function(){
        var id = $(this).data("popup");
        console.log(id);
        $(".js-imap-popup").removeClass("active");
        $("#popup-" + id).addClass("active");
    });

    $(".js-imap-close").click(function(){
        $(".js-imap-popup").removeClass("active");
    });
});
